var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.703 177.326l300-74.831 192.134 9.438L225.67 221.821z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M18.703 177.326v49.888l208.264 44.483-1.312-49.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M510.837 165.191v-53.258L225.669 221.82l-.014-.003 1.311 49.88.051.011z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.304 129.789l300-74.831 192.134 9.438L207.27 174.283z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M.304 129.789v49.887l208.264 44.484-1.312-49.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M492.438 117.654V64.396L207.27 174.283l-.014-.003 1.312 49.88.05.01z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.892 75.257l300-74.831 192.134 9.438-285.168 109.887z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M19.892 75.257v49.888l208.264 44.483-1.313-49.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M512.026 63.122V9.864L226.858 119.751l-.015-.003 1.313 49.88.05.011z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M310.227 27.084c12.826 0 24.636.665 34.702 1.99 20.22 2.658 27.717 7.287 27.992 10.731.273 3.444-6.396 9.202-25.94 15.029-17.868 5.328-41.89 9.392-67.646 11.444-25.754 2.051-50.117 1.842-68.603-.59-20.219-2.66-27.718-7.288-27.991-10.732-.712-8.937 37.547-22.007 93.583-26.472 11.731-.935 23.172-1.4 33.903-1.4zm-64.784 44.16c10.827 0 22.36-.47 34.177-1.41 25.994-2.07 50.28-6.184 68.381-11.581 13.354-3.982 29.135-10.464 28.475-18.73-.659-8.267-17.266-12.169-31.082-13.987-18.727-2.463-43.357-2.68-69.352-.608-47.822 3.81-98.019 15.728-96.857 30.311.658 8.267 17.265 12.169 31.08 13.986 10.217 1.343 22.188 2.019 35.178 2.019z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentStack);
export default __webpack_public_path__ + "static/media/document_stack.1632c020.svg";
export { ForwardRef as ReactComponent };